module.exports = __webpack_public_path__ + "static/media/discover.99fcaab7.svg";